import React, { Fragment, useCallback, useState, type FC } from "react";
import { NutritionMealTable } from "./NutritionMealTable";
import { EditorMode } from "@/app/nutrition/editor-mode.enum";
import { Meal } from "@/app/nutrition/meal.enum";
import { Option } from "@/app/nutrition/option.enum";

export type NutritionOverviewProps = {
  isLoading?: boolean;
  macros?: any;
  nutrition?: any;
  supplementations?: any;
  equivalences?: any;
  nutritionalInformations?: any;
  plan?: any;
};

export const NutritionOverview: FC<NutritionOverviewProps> = ({
  isLoading,
  supplementations,
  equivalences,
  nutritionalInformations,
  nutrition,
  macros,
  plan,
}) => {
  const editorMode = EditorMode.TrainingDay;

  const [currentOption, setCurrentOption] = useState({
    [Meal.Breakfast]: Option.First,
    [Meal.Lunch]: Option.First,
    [Meal.Meal]: Option.First,
    [Meal.Snack]: Option.First,
    [Meal.Dinner]: Option.First,
    [Meal.Redinner]: Option.First,
  });

  const handleCurrentOptionChange = useCallback(
    (option: Option, meal: Meal) => {
      setCurrentOption((currentOption) => ({
        ...currentOption,
        [meal]: option,
      }));
    },
    []
  );

  return (
    <div className="flex flex-col p-4">
      {isLoading ? (
        <Fragment />
      ) : (
        <Fragment>
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Breakfast}
            suplementations={supplementations[Meal.Breakfast]}
            options={nutrition[Meal.Breakfast] ?? {}}
            macros={macros[Meal.Breakfast]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Lunch}
            suplementations={supplementations[Meal.Lunch]}
            options={nutrition[Meal.Lunch] ?? {}}
            macros={macros[Meal.Lunch]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Meal}
            suplementations={supplementations[Meal.Meal]}
            options={nutrition[Meal.Meal] ?? {}}
            macros={macros[Meal.Meal]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Snack}
            suplementations={supplementations[Meal.Snack]}
            options={nutrition[Meal.Snack] ?? {}}
            macros={macros[Meal.Snack]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Dinner}
            suplementations={supplementations[Meal.Dinner]}
            options={nutrition[Meal.Dinner] ?? {}}
            macros={macros[Meal.Dinner]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
          <NutritionMealTable
            readonly
            editorMode={editorMode}
            meal={Meal.Redinner}
            suplementations={supplementations[Meal.Redinner]}
            options={nutrition[Meal.Redinner] ?? {}}
            macros={macros[Meal.Redinner]}
            equivalences={equivalences}
            nutritionalInformations={nutritionalInformations}
            onCurrentOptionChange={handleCurrentOptionChange}
          />
        </Fragment>
      )}
    </div>
  );
};
